import React from 'react';
import { Box, Button, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { RowAction } from '../../../../../components/row-action';
import { formatDocument } from '../../../../../utils/document';
import { formatDate } from '../../../../../utils/date';
import { formatCurrency } from '../../../../../utils/format';
import { AmendmentDetailController } from '../context/amendment-detail-controller';
import { useAmendmentDetailState } from '../context/amendment-detail-context';
import { EmptyRow, dashIfEmpty } from './detail-parts';
import { LiquidationsPanel } from './liquidations-panel';

const COLUMN_COUNT = 7;

export function CommitmentsTab({ ctrl }: { ctrl: AmendmentDetailController }) {
    const { commitments, selectedCommitment } = useAmendmentDetailState();

    return (
        <React.Fragment>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1, gap: 1, flexWrap: 'wrap' }}>
                <Typography variant="caption" color="text.secondary">Clique em um empenho para ver e gerenciar suas liquidações</Typography>
                <Button variant="contained" startIcon={<AddIcon />} onClick={() => ctrl.openDrawer('commitmentDrawer')}>Novo Empenho</Button>
            </Box>
            <TableContainer>
                <Table size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell width={40} />
                            <TableCell>Nº Empenho</TableCell>
                            <TableCell>Data</TableCell>
                            <TableCell>Fornecedor</TableCell>
                            <TableCell>Documento</TableCell>
                            <TableCell align="right">Valor Empenhado</TableCell>
                            <TableCell align="right">Ações</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {commitments.length === 0 && <EmptyRow colSpan={COLUMN_COUNT} message="Nenhum empenho cadastrado" />}
                        {commitments.map((commitment) => {
                            const isExpanded = selectedCommitment?.id === commitment.id;
                            return (
                                <React.Fragment key={commitment.id}>
                                    <TableRow
                                        hover
                                        selected={isExpanded}
                                        sx={{ cursor: 'pointer', '& td': { borderBottom: isExpanded ? 'none' : undefined } }}
                                        onClick={() => ctrl.handleToggleCommitment(commitment)}
                                    >
                                        <TableCell>
                                            <IconButton size="small" aria-label={isExpanded ? 'Recolher liquidações' : 'Ver liquidações'}>
                                                {isExpanded ? <ExpandLessIcon fontSize="small" /> : <ExpandMoreIcon fontSize="small" />}
                                            </IconButton>
                                        </TableCell>
                                        <TableCell sx={{ fontWeight: 600 }}>{dashIfEmpty(commitment.commitmentNumber)}</TableCell>
                                        <TableCell>{dashIfEmpty(formatDate(commitment.commitmentDate))}</TableCell>
                                        <TableCell>{dashIfEmpty(commitment.supplierName)}</TableCell>
                                        <TableCell>{dashIfEmpty(formatDocument(commitment.supplierDocument))}</TableCell>
                                        <TableCell align="right" sx={{ fontWeight: 600 }}>{formatCurrency(commitment.committedAmount)}</TableCell>
                                        <TableCell align="right" onClick={(e) => e.stopPropagation()}>
                                            <Box sx={{ display: 'inline-flex' }}>
                                                <RowAction title="Editar" onClick={() => ctrl.openDrawer('commitmentDrawer', { record: commitment })}><EditIcon fontSize="small" /></RowAction>
                                                <RowAction title="Excluir" color="error" onClick={() => ctrl.deleteCommitment(commitment)}><DeleteIcon fontSize="small" /></RowAction>
                                            </Box>
                                        </TableCell>
                                    </TableRow>
                                    {isExpanded && (
                                        <TableRow>
                                            <TableCell colSpan={COLUMN_COUNT} sx={{ p: 0, border: 'none' }}>
                                                <LiquidationsPanel commitment={commitment} ctrl={ctrl} />
                                            </TableCell>
                                        </TableRow>
                                    )}
                                </React.Fragment>
                            );
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
        </React.Fragment>
    );
}
